export const SIXTY_FPS = 1000 / 60;
